import * as yup from 'yup';
import { SuggestionSchema } from '../../../common';

export const SocialCareSuggestionSchema = yup.object({
  offers: SuggestionSchema.nullable(),
});

export type ISocialCareSuggestion = yup.InferType<typeof SocialCareSuggestionSchema>;
